// extracted by mini-css-extract-plugin
module.exports = {"statsContainer":"Stats_statsContainer__2tYcU","statsBox":"Stats_statsBox__1nWc2","number":"Stats_number__woYRj","title":"Stats_title__2XlKo"};